import { Checkbox } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function SelectAllItem({
  selectedCount,
  allCount,
  selectAll,
  deselectAll,
}: {
  selectedCount: number;
  allCount: number;
  selectAll: () => void;
  deselectAll: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex justify-between items-center w-full">
      <div className="whitespace-nowrap truncate text-sm font-semibold">
        {t('actions.alleAuswaehlen')} ({selectedCount} / {allCount})
      </div>
      <Checkbox
        checked={
          selectedCount === allCount
            ? true
            : selectedCount > 0
              ? 'indeterminate'
              : false
        }
        onCheckedChange={() => {
          if (allCount === selectedCount) {
            deselectAll();
          } else {
            selectAll();
          }
        }}
        className="disabled:opacity-100 disabled:cursor-auto"
      />
    </div>
  );
}
